export default __webpack_public_path__ + "/static/media/loader.71bb124d.gif";